import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import React from 'react'
import { TableCell, IconButton, Tooltip } from '@mui/material'
import { TableData, TableAction } from '../types'

interface ActionsCellProps<T extends TableData> {
  row: T
  index: number
  actions: TableAction<T>[]
}

export const ActionsCell = <T extends TableData>({
  row,
  index,
  actions
}: ActionsCellProps<T>) => {
  const styles = useStyles()

  const handleActionClick =
    (action: TableAction<T>) => (event: React.MouseEvent) => {
      event.stopPropagation() // Evitar que se active el onRowClick
      action.onClick(row, index)
    }

  const getVisibleActions = () => {
    return actions.filter((action) => (action.show ? action.show(row) : true))
  }

  const isActionDisabled = (action: TableAction<T>) => {
    return action.disabled ? action.disabled(row) : false
  }

  const getActionColor = (action: TableAction<T>) => {
    if (isActionDisabled(action)) return 'default'
    return action.color || 'default'
  }

  return (
    <TableCell align='center'>
      <div className={styles.actionsContainer}>
        {getVisibleActions().map((action) => {
          // Si la acción tiene render personalizado, usarlo
          if (action.render) {
            return <div key={action.key}>{action.render(row, index)}</div>
          }

          // Si no, usar el renderizado estándar con icono
          return (
            <Tooltip key={action.key} title={action.label} arrow>
              <span>
                {' '}
                {/* Span necesario para que el Tooltip funcione con botones deshabilitados */}
                <IconButton
                  size='small'
                  onClick={handleActionClick(action)}
                  disabled={isActionDisabled(action)}
                  color={getActionColor(action)}
                  className={styles.actionButton}
                >
                  {action.icon}
                </IconButton>
              </span>
            </Tooltip>
          )
        })}
      </div>
    </TableCell>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  actionsContainer: {
    display: 'flex',
    gap: theme.spacing(0.5),
    justifyContent: 'center',
    alignItems: 'center'
  },
  actionButton: {
    padding: theme.spacing(0.5)
  }
}))
